export const NON_CONCURRENT_ELASTICSEARCH_TIME = 1600;
